import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { CabinExperiencesComponent } from './cabin-experiences.component';

@NgModule({ declarations: [CabinExperiencesComponent],
    exports: [CabinExperiencesComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CabinExperiencesModule {}
